<!-- <amplify-authenticator> -->
<router-outlet (activate)="onActivate($event)"></router-outlet>
<app-cookie-banner></app-cookie-banner>
<!-- </amplify-authenticator> -->
